// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  /* font sizes in vuetify are in rem units. To get the correct font size, the html tag has to have a font size of 
     * 16px */
  font-size: 16px;
}

:where(.vuetify-styles) div.v-application--wrap {
  /* disable min-height: 100vh set by vuetify */
  min-height: unset;
}

.vuetify-styles {
  /* Rules set on the html element in the vuetify styles are no longer applied after prefixing all selectors, so copy
     * them here. */
  overflow-x: hidden;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  /* From _reset.scss */
  box-sizing: border-box;
}

/* fix for override from jp-ThemedContainer button */
button.v-btn--rounded {
  border-radius: 28px;
}
`, "",{"version":3,"sources":["webpack://./lib/styles.css"],"names":[],"mappings":"AAAA;EACE;aACW;EACX,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE;mBACiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,6CAA6C;;EAE7C,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;AACrB","sourcesContent":["html {\n  /* font sizes in vuetify are in rem units. To get the correct font size, the html tag has to have a font size of \n     * 16px */\n  font-size: 16px;\n}\n\n:where(.vuetify-styles) div.v-application--wrap {\n  /* disable min-height: 100vh set by vuetify */\n  min-height: unset;\n}\n\n.vuetify-styles {\n  /* Rules set on the html element in the vuetify styles are no longer applied after prefixing all selectors, so copy\n     * them here. */\n  overflow-x: hidden;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\n  /* From _reset.scss */\n  box-sizing: border-box;\n}\n\n/* fix for override from jp-ThemedContainer button */\nbutton.v-btn--rounded {\n  border-radius: 28px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
